import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import EntityPage from 'components/EntityPage';
import {
  fetchEntities,
  createEntity,
  updateEntity,
  archiveEntity,
  entitiesCleanUp,
} from 'state/actions/satellites';

import CONSTANTS from 'utils/constants';
import EntityProfile from './Profile';
import EntityForm from './Form';
import entitySchema from './schema';

export default () => {
  const {
    i18nEntityName,
    entitiesName,
    entityName,
    PATH_ENTITIES,
  } = CONSTANTS.ENTITIES.SATELLITES;

  const entityInfos = {
    i18nEntityName,
    entitiesName,
    entityName,
    PATH_ENTITIES,
  };
  const entityActions = {
    fetchEntities,
    createEntity,
    updateEntity,
    archiveEntity,
    entitiesCleanUp,
  };

  // // Get data from store
  // const { entity = {} } = useSelector(
  //   (state) => ({
  //     entity: state[entityInfos.entitiesName].data.find(
  //       (_entity) => _entity && _entity.id === id
  //     ),
  //   }),
  //   shallowEqual
  // );

  const dispatch = useDispatch();

  // Fetch data
  useEffect(() => {
    dispatch(fetchEntities());
  }, [dispatch]);

  const options = {};

  const { yupSchema } = entitySchema;
  return (
    <EntityPage
      yupSchema={yupSchema}
      entityInfos={entityInfos}
      entityActions={entityActions}
      Profile={EntityProfile}
      Form={EntityForm}
      options={options}
    />
  );
};
